module.exports = __webpack_public_path__ + "static/media/focus.14a87f74.svg";